import React from 'react';
import { CardContent } from '@material-ui/core';
import { CardWithClearing } from '../Card';
import { EmptyState, EmptyStateProps } from './EmptyState';

export const EmptyStateCard: React.FunctionComponent<EmptyStateProps> = props => {
    return (
        <CardWithClearing>
            <CardContent>
                <EmptyState {...props}/>
            </CardContent>
        </CardWithClearing>
    );
};
